module.exports = __webpack_public_path__ + "static/media/1682618681122_1694720753568.cb15e39f.jpeg";